import "./00-jwplayer";
import SSAudioVideoBar from "./00-slideshare_audio_video_bar";

function SSVideoBar(config){
  SSAudioVideoBar.call(this, config);
  this.spinnerDelay = 1500;
  this.setWidthsForVideoBar();
}

SSVideoBar.prototype = new SSAudioVideoBar();

SSVideoBar.prototype.activate = function(){
};

SSVideoBar.prototype.setWidthsForVideoBar = function() {
  var navActions = $('.toolbar .navActions a:visible, .toolbar .navActions>button:visible');
  this.ACTIONS_WIDTH = 0;
  var that = this;

  $.each(navActions, function(i, obj) {
    that.ACTIONS_WIDTH += $(obj).width();
  });
  this.TOOLBAR_PADDING_RIGHT = parseInt($('.toolbar').css('padding-right'), 10);
  this.TOOLBAR_PADDING_LEFT = parseInt($('.toolbar').css('padding-left'), 10);
};

SSVideoBar.prototype.showTimeValues = function() {
  this.totalLength = Math.floor(this.videoPlayer.getDuration());
  this.totalHours = Math.floor(this.totalLength/3600);

  this._getTime = this._getTimeHourRange; // removing hour check as now we want all time to be shown in hh:mm:ss format
  this.totalInfoElement.text(this._getTime(this.totalLength));

  this.progressInfoElement.text('00:00');
};

SSVideoBar.prototype.updateBuffer = function(bufferPercent) {
  this.bufferProgress.css('width', bufferPercent + '%');
};

SSVideoBar.prototype.renderSeekBar = function(){
  // In video files, we don't need markers
  // Instead obtain the file length and setup the progress bar
  this.container.show();
  this.activate();
};

SSVideoBar.prototype.addVideoListeners = function() {
  var vid = document.getElementsByTagName("video")[0], that = this;
  this.vid = vid;
  this.playReady && vid && vid.webkitEnterFullscreen();
  this.vid.addEventListener('canplaythrough', function(evt) {
    that.playReady = true;
    vid.webkitEnterFullscreen();
    setTimeout(function() {
      $('.fakeClicker').hide();
      $('.slideDisplayer').css('-webkit-transform', 'translateX(0px)');
      that.vid.webkitEnterFullscreen();
    }, 500);
    that.vid.play();
  });
  
  this.vid.addEventListener('webkitendfullscreen', function(evt) {
    that.vid.pause();
  });
  
  this.vid.addEventListener('webkitbeginfullscreen', function(evt) {
    !that.playReady && that.vid.webkitExitFullscreen();
    that.playReady && that.vid.play();
  });
  
  this.vid.addEventListener('ended', function(evt) {
    that.vid.webkitExitFullscreen();
  });
};

SSVideoBar.prototype._bindEvents = function(){
  var that = this;
  this.videoPlayer = window.jwplayer();

  // jwplayer specific action bindings.
  this.videoPlayer.onComplete(function() {
    $('.btnAudio').removeClass('btnAudioPause').addClass('btnAudioPlay').attr('title', 'Pause');
    $.slideshareEventManager.trigger('showlastscreen');
  });

  this.videoPlayer.onBufferChange(function(bufferData) {
    that.updateBuffer(bufferData.bufferPercent);
  });
  
  // handler for playing time updates
  this.videoPlayer.onTime(function(timeData) {
    if(that.spinnerShown && timeData.position > that.seekedTime){
      $.slideshareEventManager.trigger('hidevideospinner');
      that.spinnerShown = false;
    }
    that.updateProgress(parseInt(timeData.position*1000, 10));
  });

  this.videoPlayer.onPlay(function(state) {
    if(that.config.isMobileAndNonIos) {
      // This function should not be executed for ios cause sometimes 'canplaythrough' 
      // won't dispatch and it will cause the player to crash unexpectedly whithout any errors.
      that.addVideoListeners();
    }

    $('.toolbar').css('z-index', $('.slideDisplayer').css('z-index'));
    if(state.oldstate !== 'PLAYING') {
      that.showTimeValues();
    }    
    $('.btnAudio').removeClass('btnAudioPlay').addClass('btnAudioPause').attr('title', 'Play');
  });

  this.videoPlayer.onPause(function(oldstate) {
    $('.btnAudio').removeClass('btnAudioPause').addClass('btnAudioPlay').attr('title', 'Pause');
  });

  this.videoPlayer.onFullscreen(function(data) {
    that.fullscreen = data.fullscreen;
  });

  $('.jspl_audiobar_left').on('click', function(e) {
    var $progressBar = $(this).find('.jspl_audiobar_progress');
    var offset = $progressBar.offset();
    var clickx = e.pageX - offset.left;
    var progressBarWidth = $progressBar.width();
    var position = Math.ceil((clickx/progressBarWidth)*that.totalLength);

    that.updateProgress(parseInt(position*1000, 10));
    $(that.playProgress).css('width', (clickx/progressBarWidth * 100) + '%');
    if(that.videoPlayer.getRenderingMode() !== "flash") {
      var bufferedData = that.videoPlayer.getBuffer() * that.totalLength / 100;
      that.seekedTime = position;
      if(bufferedData < that.seekedTime){
        $.slideshareEventManager.trigger('showvideospinner');
        that.spinnerShown = true;
      }
    }

    that.videoPlayer.seek(position);
  });

  $('.j-modal-close').click(function () {
    that.play();
  });

  $('.jspl_audiobar_left').on('mouseleave', function(e) {
    that.hideToolTip();
  }).on('mousemove', function(e) {
    var $progressBar = $(this).find('.jspl_audiobar_progress');
    var offset = $progressBar.offset();
    var clickx = e.pageX - offset.left;
    var progressBarWidth = $progressBar.width();
    var position = Math.ceil((clickx / progressBarWidth) * that.totalLength);

    that.updateToolTip(parseInt(position*1000, 10));
  });
};

SSVideoBar.prototype.changeVolume = function(vol) {
  this.videoPlayer.setVolume(vol);
};

SSVideoBar.prototype.pause = function() {
  this.videoPlayer.pause(true);
};

SSVideoBar.prototype.play = function(mode, time) {
  this.videoPlayer = window.jwplayer();
  this.videoPlayer.play(true);
};

SSVideoBar.prototype.togglePlay = function() {
  this.videoPlayer && this.videoPlayer.play();
};

SSVideoBar.prototype.isPlaying = function() {
  return this.videoPlayer && this.videoPlayer.getState() === "PLAYING";
};

export default SSVideoBar;
